<template>
  <div>
    <div class="main-homepage-4">
      <div class="slider-style4">
        <div class="container">
          <div class="row">
            <div class="col-lg-12">
              <div class="title-section">
                <h3 class="our-product-title">
                  <a></a>
                </h3>
                <h1 class="our-product-main">
                  <a>Hot Items</a>
                </h1>
                <div class="our-product-image">
                  <img src="@/assets/images/homepage14.png" alt="image" />
                </div>
              </div>
              <!-- /title-section -->
            </div>
            <div class="col-lg-1"></div>
            <div class="col-lg-10">
              <div
                class="flat-carousel-box data-effect clearfix"
                data-gap="30"
                data-column="4"
                data-column2="2"
                data-column3="1"
                data-dots="false"
                data-nav="true"
                data-auto="false"
              >
                <div class="owl-carousel">
                  <div
                    class="product-item style4"
                    v-for="(item, index) in hot_products"
                    :key="index"
                    @click.stop="onProductItemClick(item)"
                  >
                    <div class="product-thumb clearfix">
                      <a class="product-thumb">
                        <img :src="item.imgthumb || defaultImgUrl" alt />
                      </a>
                    </div>
                    <div class="product-info text-center clearfix">
                      <span
                        v-tooltip="{
                          content: item.productName,
                          trigger: 'hover'
                        }"
                        class="product-title"
                        >{{ item.productName }}</span
                      >
                      <div class="price">
                        <span class="amount">
                          {{
                            item.currencyKind +
                              (item.isPromotion
                                ? item.promotionPrice
                                : item.price)
                          }}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-lg-1"></div>
          </div>
          <!-- /row -->
        </div>
        <!-- /container -->
      </div>
      <!-- /slider-style4 -->
    </div>

    <section class="flat-about style4">
      <div class="container">
        <div class="row">
          <div class="col-lg-12">
            <div class="about-wrap">
              <div class="about-image">
                <div id="about-image">
                  <img
                    src="@/assets/images/微信图片_20200810010752.jpg"
                    style="border-radius:5px;"
                    alt="image"
                  />
                  <img
                    src="@/assets/images/微信图片_20200810010801.jpg"
                    style="border-radius:5px;"
                    alt="image"
                  />
                  <img
                    src="@/assets/images/微信图片_20200810010808.jpg"
                    style="border-radius:5px;"
                    alt="image"
                  />
                </div>
              </div>

              <div class="about-inner">
                <div class="flat-divider margin-top50px"></div>
                <div class="title-section">
                  <h3 class="our-product-title">
                    <a></a>
                  </h3>
                  <h1 class="our-product-main">
                    <a>Welcome To Mega Wine</a>
                  </h1>
                  <div class="our-product-image">
                    <img src="@/assets/images/homepage14.png" alt="image" />
                  </div>
                </div>
                <!-- /title-section -->
                <div class="about-content text-center">
                  <p>
                    We established a few years ago by a group of qualified WSET
                    wine experts. We have offices in HongKong, Zhongshan,
                    Shanghai ,Chengdu and we are expanding into Beijing and some
                    major cities in China.
                  </p>
                </div>
                <div class="elm-btn" style="cursor: pointer;">
                  <a
                    @click="onAboutMoreClick"
                    class="themesflat-button outline ol-accent margin-top-40 hvr-shutter-out-horizontal"
                    >LEARN MORE</a
                  >
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="flat-our-product style4">
      <div class="container">
        <div class="row">
          <div class="col-lg-12">
            <div class="title-section">
              <h3 class="our-product-title">
                <a></a>
              </h3>
              <h1 class="our-product-main">
                <a>Recommended Products</a>
              </h1>
              <div class="our-product-image">
                <img src="@/assets/images/homepage14.png" alt="image" />
              </div>
            </div>
            <!-- /title-section -->
          </div>
          <div class="col-lg-2">
            <div class="products-menu">
              <ul>
                <li
                  style="cursor:pointer;"
                  v-bind:class="{ active: currentKindGuid === item.kindGuid }"
                  v-for="(item, index) in product_kind"
                  :key="index"
                  @click.stop="onKindItemClick(item)"
                >
                  <a>{{ item.kindName + '(' + item.total + ')' }}</a>
                </li>
              </ul>
            </div>
          </div>
          <div class="col-lg-10">
            <div
              class="flat-carousel-box data-effect clearfix"
              data-gap="30"
              data-column="3"
              data-column2="2"
              data-column3="1"
              data-dots="false"
              data-nav="true"
              data-auto="false"
            >
              <div class="owl-carousel">
                <div
                  class="product-item"
                  v-for="(item, index) in recommend_products"
                  :key="index"
                  @click.stop="onProductItemClick(item)"
                >
                  <div class="product-thumb clearfix">
                    <a class="product-thumb">
                      <img :src="item.imgthumb || defaultImgUrl" alt />
                    </a>
                  </div>
                  <div class="product-info text-center clearfix">
                    <span
                      v-tooltip="{
                        content: item.productName,
                        trigger: 'hover'
                      }"
                      class="product-title"
                      >{{ item.productName }}</span
                    >
                    <div class="price">
                      <ins v-if="item.isPromotion">
                        <span class="amount">{{
                          item.currencyKind + item.promotionPrice
                        }}</span>
                        <del>{{ item.currencyKind + item.price }}</del>
                      </ins>
                      <ins v-else>
                        <span class="amount">{{
                          item.currencyKind + item.price
                        }}</span>
                      </ins>
                    </div>
                  </div>
                  <div class="product-review">
                    <div class="add-cart">
                      <a href="#" class="like1">
                        <i class="fa fa-refresh" aria-hidden="true"></i>
                      </a>
                    </div>
                    <div class="add-cart">
                      <a href="#" class="like2">
                        <i class="fa fa-heart-o"></i>
                      </a>
                    </div>
                    <div class="add-cart">
                      <a href="#" class="like3">
                        <i class="fa fa-shopping-cart" aria-hidden="true"></i>
                      </a>
                    </div>
                  </div>
                </div>
                <!-- /product-item -->
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="flat-deal-of-the-week style2">
      <div class="container">
        <div class="row">
          <div class="col-lg-6">
            <img src="@/assets/images/蜂蜜浏览器_homepage142.png" alt="image" />
          </div>
          <div class="col-lg-6">
            <div class="title-section">
              <h3 class="our-product-title">
                <a></a>
              </h3>
              <h1 class="our-product-main">
                <a>Wine Tasting This Month</a>
              </h1>
              <div class="our-product-image">
                <img src="@/assets/images/homepage14.png" alt="image" />
              </div>
            </div>
            <!-- /title-section -->
            <div class="deal-week-content text-center">
              <p>
                Due to the COVID-19, Wine Tasting scheduled on 1/May will be
                cancelled.
              </p>
            </div>
            <div
              class="flat-counter count-time"
              data-day="25"
              data-month="4"
              data-year="2020"
              data-hour="19"
              data-minute="00"
              data-second="00"
            >
              <div class="counter">
                <ul>
                  <li class="content-counter">
                    <div class="wrap-bg">
                      <div class="inner-bg days">
                        <div
                          class="numb-count numb"
                          data-from="0"
                          data-to="18"
                          data-speed="2000"
                          data-inviewport="yes"
                        >
                          0
                        </div>
                        <div class="name-count">Day</div>
                      </div>
                    </div>
                  </li>
                  <li class="content-counter">
                    <div class="wrap-bg">
                      <div class="inner-bg hours">
                        <div
                          class="numb-count numb"
                          data-from="0"
                          data-to="11"
                          data-speed="2000"
                          data-inviewport="yes"
                        >
                          0
                        </div>
                        <div class="name-count">Hour</div>
                      </div>
                    </div>
                  </li>
                  <li class="content-counter">
                    <div class="wrap-bg">
                      <div class="inner-bg minutes">
                        <div
                          class="numb-count numb"
                          data-from="0"
                          data-to="14"
                          data-speed="2000"
                          data-inviewport="yes"
                        >
                          0
                        </div>
                        <div class="name-count">Min</div>
                      </div>
                    </div>
                  </li>
                  <li class="content-counter">
                    <div class="wrap-bg numb">
                      <div class="inner-bg seconds">
                        <div
                          class="numb-count numb"
                          data-from="0"
                          data-to="47"
                          data-speed="2000"
                          data-inviewport="yes"
                        >
                          0
                        </div>
                        <div class="name-count">Sec</div>
                      </div>
                    </div>
                  </li>
                </ul>
              </div>
              <!-- /counter -->
            </div>
            <!-- /flat-counter -->
            <!-- <div class="elm-btn" style="cursor: pointer;">
              <a
                class="themesflat-button outline ol-accent margin-top-40 hvr-shutter-out-horizontal"
                >JOIN</a
              >
            </div>-->
          </div>
          <!-- /col-lg-6 -->
        </div>
        <!-- /row -->
      </div>
      <!-- /container -->
    </section>
    <!-- /flat-deal-of-the-week style2 -->
    <section class="flat-products style1">
      <div class="container">
        <div class="row">
          <div class="col-lg-4 col-md-4 col-sm-4">
            <div class="flat-latest flat-latest1">
              <div class="latest-title mb-mgtop0">
                <h3>
                  <a href="#">New Products</a>
                </h3>
              </div>
              <div class="flat-next">
                <a href="#">
                  <i class="fa fa-chevron-right" aria-hidden="true"></i>
                </a>
              </div>
              <article
                class="post-border"
                v-bind:class="{
                  'post-top': index === 0,
                  'post-between': index !== 0
                }"
                v-for="(item, index) in recent_products"
                :key="index"
                @click.stop="onProductItemClick(item)"
              >
                <div class="featured-post">
                  <img
                    :src="item.imgthumb || defaultImgUrl"
                    width="28"
                    alt="image"
                  />
                </div>
                <div class="content-post">
                  <div
                    class="post-title"
                    v-tooltip="{ content: item.productName, trigger: 'hover' }"
                  >
                    <span>
                      <a>{{ item.productName }}</a>
                    </span>
                  </div>
                  <div class="post-dolar">
                    <p v-if="item.isPromotion">
                      <span class="amount">{{
                        item.currencyKind + item.promotionPrice
                      }}</span>
                      <del>{{ item.currencyKind + item.price }}</del>
                      &nbsp;&nbsp;&nbsp;
                      <span>
                        {{
                          Math.round((1 - item.defaultDiscount) * 100) + '%off'
                        }}
                      </span>
                    </p>
                    <p v-else>
                      <span class="amount">{{
                        item.currencyKind + item.price
                      }}</span>
                    </p>
                  </div>
                  <div class="post-rating">
                    <i class="fa fa-star" aria-hidden="true"></i>
                    <i class="fa fa-star" aria-hidden="true"></i>
                    <i class="fa fa-star" aria-hidden="true"></i>
                    <i class="fa fa-star" aria-hidden="true"></i>
                    <i class="fa fa-star" aria-hidden="true"></i>
                  </div>
                </div>
              </article>
            </div>
          </div>
          <!-- /col-lg-4 -->
          <div class="col-lg-4 col-md-4 col-sm-4">
            <div class="flat-latest flat-latest3">
              <div class="latest-title title-bottom">
                <h3>
                  <a href="#">Hot Items</a>
                </h3>
              </div>
              <div class="flat-next">
                <a href="#">
                  <i class="fa fa-chevron-right" aria-hidden="true"></i>
                </a>
              </div>
              <article
                class="post-border"
                v-bind:class="{
                  'post-top': index === 0,
                  'post-between': index !== 0
                }"
                v-for="(item, index) in product_popular"
                :key="index"
                @click.stop="onProductItemClick(item)"
              >
                <div class="featured-post">
                  <img
                    :src="item.imgthumb || defaultImgUrl"
                    width="28"
                    alt="image"
                  />
                </div>
                <div class="content-post">
                  <div
                    class="post-title"
                    v-tooltip="{ content: item.productName, trigger: 'hover' }"
                  >
                    <span>
                      <a>{{ item.productName }}</a>
                    </span>
                  </div>
                  <div class="post-dolar">
                    <p v-if="item.isPromotion">
                      <span class="amount">{{
                        item.currencyKind + item.promotionPrice
                      }}</span>
                      <del>{{ item.currencyKind + item.price }}</del>
                      &nbsp;&nbsp;&nbsp;
                      <span>
                        {{
                          Math.round((1 - item.defaultDiscount) * 100) + '%off'
                        }}
                      </span>
                    </p>
                    <p v-else>
                      <span class="amount">{{
                        item.currencyKind + item.price
                      }}</span>
                    </p>
                  </div>
                  <div class="post-rating">
                    <i class="fa fa-star" aria-hidden="true"></i>
                    <i class="fa fa-star" aria-hidden="true"></i>
                    <i class="fa fa-star" aria-hidden="true"></i>
                    <i class="fa fa-star" aria-hidden="true"></i>
                    <i class="fa fa-star" aria-hidden="true"></i>
                  </div>
                </div>
              </article>
            </div>
          </div>
          <!-- /col-lg-4 -->
          <div class="col-lg-4 col-md-4 col-sm-4">
            <div class="flat-latest flat-latest2">
              <div class="latest-title title-between">
                <h3>
                  <a href="#">Special Offers</a>
                </h3>
              </div>
              <div class="flat-next">
                <a href="#">
                  <i class="fa fa-chevron-right" aria-hidden="true"></i>
                </a>
              </div>
              <article
                class="post-border"
                v-bind:class="{
                  'post-top': index === 0,
                  'post-between': index !== 0
                }"
                v-for="(item, index) in toprated_products"
                :key="index"
                @click.stop="onProductItemClick(item)"
              >
                <div class="featured-post">
                  <img
                    :src="item.imgthumb || defaultImgUrl"
                    width="28"
                    alt="image"
                  />
                </div>
                <div class="content-post">
                  <div
                    class="post-title"
                    v-tooltip="{ content: item.productName, trigger: 'hover' }"
                  >
                    <span>
                      <a>{{ item.productName }}</a>
                    </span>
                  </div>
                  <div class="post-dolar">
                    <span class="amount">{{
                      item.currencyKind + item.promotionPrice
                    }}</span>
                    <del>{{ item.currencyKind + item.price }}</del
                    >&nbsp;&nbsp;&nbsp;
                    <span>
                      {{
                        Math.round((1 - item.defaultDiscount) * 100) + '%off'
                      }}
                    </span>
                  </div>
                  <div class="post-rating">
                    <i class="fa fa-star" aria-hidden="true"></i>
                    <i class="fa fa-star" aria-hidden="true"></i>
                    <i class="fa fa-star" aria-hidden="true"></i>
                    <i class="fa fa-star" aria-hidden="true"></i>
                    <i class="fa fa-star" aria-hidden="true"></i>
                  </div>
                </div>
              </article>
            </div>
          </div>
          <!-- /col-lg-4 -->
        </div>
        <!-- /row -->
      </div>
      <!-- /container -->
    </section>
    <!-- /flat-dblog -->
  </div>
</template>
<script>
var countDownTime = function() {
  $('.count-time').each(function() {
    var day = $('.count-time').data('day'),
      month = $('.count-time').data('month') - 1,
      year = $('.count-time').data('year'),
      hour = $('.count-time').data('hour'),
      minute = $('.count-time').data('minute'),
      second = $('.count-time').data('second')

    var countDownDate = new Date(
      year,
      month,
      day,
      hour,
      minute,
      second
    ).getTime()

    // Update the count down every 1 second
    var x = setInterval(function() {
      // Get todays date and time
      var now = new Date().getTime()

      // Find the distance between now and the count down date
      var distance = countDownDate - now

      // Time calculations for days, hours, minutes and seconds
      var days = Math.floor(distance / (1000 * 60 * 60 * 24))
      var hours = Math.floor(
        (distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
      )
      var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60))
      var seconds = Math.floor((distance % (1000 * 60)) / 1000)

      // Display the result in the element with id="demo"
      $('.days .numb').html(days)
      $('.hours .numb').html(hours)
      $('.minutes .numb').html(minutes)
      $('.seconds .numb').html(seconds)

      // If the count down is finished, write some text
      if (distance < 0) {
        clearInterval(x)
        $('.days .numb').html('0')
        $('.hours .numb').html('0')
        $('.minutes .numb').html('0')
        $('.seconds .numb').html('0')
      }
    }, 1000)
  })
}

import 'owl.carousel'
import { tns } from 'tiny-slider/src/tiny-slider.js'
//import { tns } from "tiny-slider";
import 'magnific-popup'
import newWebsiteNotice from '@/components/NewWebsiteNotice'

export default {
  data() {
    return {
      defaultImgUrl: require('../../assets/images/default279x900.png'),
      recommend_products: [],
      hot_products: [],
      product_kind: [],
      product_popular: [],
      recent_products: [],
      toprated_products: [],
      currentKindGuid: ''
    }
  },
  mounted() {
    tns({
      container: '#about-image',
      items: 1,
      loop: true,
      controls: false,
      autoplay: true,
      swipeAngle: false,
      nav: false
    })
    //this.queryHotSale()
    this.queryProductKindByRecommend()
    this.queryRecentProducts()
    this.queryPopularProduct()
    this.queryTopTatedProduct()
  },
  methods: {
    showTipDialog() {
      let dlg_options = {
        maxButton: false,
        title: '',
        backdropClose: true
      }
      if (document.body.clientWidth < 700) {
        dlg_options.width = document.body.clientWidth
      }
      this.$dlg.modal(newWebsiteNotice, dlg_options)
    },
    init() {
      if ($().owlCarousel) {
        $('.flat-carousel-box').each(function() {
          var $this = $(this),
            auto = $this.data('auto'),
            item = $this.data('column'),
            item2 = $this.data('column2'),
            item3 = $this.data('column3'),
            gap = Number($this.data('gap')),
            dots = $this.data('dots'),
            nav = $this.data('nav')

          $this.find('.owl-carousel').owlCarousel({
            margin: gap,
            loop: true,
            dots: dots,
            nav: true,
            navigation: true,
            pagination: true,
            autoplay: auto,
            autoplayTimeout: 5000,
            responsive: {
              0: {
                items: item3
              },
              765: {
                items: item2
              },
              1000: {
                items: item
              }
            }
          })
        })
      }
      if ($().countTo) {
        $('.counter').on('on-appear', function() {
          $(this)
            .find('.numb-count')
            .each(function() {
              var to = $(this).data('to'),
                speed = $(this).data('speed')

              $(this).countTo({
                to: to,
                speed: speed
              })
            })
        })
      }
      countDownTime()
    },
    initCarousel() {
      if ($().owlCarousel) {
        $('.flat-our-product .flat-carousel-box').each(function() {
          var $this = $(this),
            auto = $this.data('auto'),
            item = $this.data('column'),
            item2 = $this.data('column2'),
            item3 = $this.data('column3'),
            gap = Number($this.data('gap')),
            dots = $this.data('dots'),
            nav = $this.data('nav')

          $this.find('.owl-carousel').owlCarousel({
            margin: gap,
            loop: true,
            dots: dots,
            nav: true,
            navigation: true,
            pagination: true,
            autoplay: auto,
            autoplayTimeout: 5000,
            responsive: {
              0: {
                items: item3
              },
              765: {
                items: item2
              },
              1000: {
                items: item
              }
            }
          })
        })
      }
    },
    onAboutMoreClick() {
      this.$router.push({
        path: '/about'
      })
    },
    onKindItemClick(item) {
      this.currentKindGuid = item.kindGuid
      this.queryRecommend()
    },
    onProductItemClick(item) {
      this.$router.push({
        path: '/product/detail',
        query: { id: item.productGUID }
      })
    },
    queryProductKindByRecommend() {
      let _this = this
      this.$http.get('/api/product/QueryProductKindByRecommend').then(res => {
        _this.product_kind = res.data
        _this.currentKindGuid = _this.product_kind[0].kindGuid
        _this.queryRecommend()
      })
    },
    queryRecommend() {
      let _this = this

      let owl = $('.flat-our-product .flat-carousel-box .owl-carousel')
      this.$http
        .get('/api/product/QueryRecommendProduct', {
          kindguid: this.currentKindGuid
        })
        .then(res => {
          owl.trigger('destroy.owl.carousel')
          _this.recommend_products = res.data
          setTimeout(() => {
            _this.initCarousel()
          }, 500)
        })
    },
    queryHotSale() {
      let _this = this
      this.$http.get('/api/product/QueryHotSaleProduct').then(res => {
        _this.hot_products = res.data
      })
    },
    queryRecentProducts() {
      let _this = this
      this.$http.get('/api/product/QueryRecentProduct').then(res => {
        _this.recent_products = res.data
      })
    },
    queryPopularProduct() {
      let _this = this
      this.$http
        .get('/api/product/QueryPopularProduct', { top: 6 })
        .then(res => {
          _this.hot_products = _this.product_popular = res.data
          setTimeout(() => {
            _this.init()
          }, 500)
        })
    },
    queryTopTatedProduct() {
      let _this = this
      this.$http
        .get('/api/product/QueryProduct', {
          page: 1,
          pagesize: 6,
          ispromotion: true,
          sort: 'BP.DefaultDiscount'
        })
        .then(res => {
          _this.toprated_products = res.data.products
        })
    }
  },
    mounted(){
      this.showTipDialog()
    }
}
</script>

<style lang="scss" scoped>
.product-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  .product-thumb {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 9rem;
    height: 20rem;
    img {
      width: auto;
      height: auto;
      max-width: 100%;
      max-height: 100%;
    }
  }

  .product-title {
    word-break: break-word;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    height: 60px;
  }
}
.about-image {
  overflow: hidden;
}
#about-image {
  height: 400px;
  img {
    height: 400px;
    object-fit: cover;
  }
}
</style>
